export default class FormacaoCursoDetailsController {
    constructor($state, $http, $filter, FileUploader, AuthenticationService, $sce, $stateParams, $timeout, FormacaoCurso, FormacaoModulo, UIService, FormacaoEdicao, FormacaoEdicaoTipo, FormacaoModalidade, FormacaoAreaInteresse, FormacaoEdicaoRegime) {
        this.$state = $state;
        this.$http = $http;
        this.$filter = $filter;
        this.FileUploader = FileUploader;
        this.$sce = $sce;
        this.id = $stateParams.id;
        this.$timeout = $timeout;
        this.FormacaoCurso = FormacaoCurso;
        this.FormacaoModulo = FormacaoModulo;
        this.FormacaoEdicao = FormacaoEdicao;
        this.FormacaoEdicaoTipo = FormacaoEdicaoTipo;
        this.FormacaoModalidade = FormacaoModalidade;
        this.FormacaoAreaInteresse = FormacaoAreaInteresse;
        this.FormacaoEdicaoRegime = FormacaoEdicaoRegime;
        this.UI = UIService;
        this.hasLoaded = false;
        // Redirect if not defined
        if (!this.id)
            this.$state.go('app.formacao.cursos.list');
        this.simnao = [{ designacao: "Sim", value: 1 }, { designacao: "Não", value: 0 }];
        this.moduleOptions = {
            containment: 'parent',
            tolerance: 'pointer',
            handle: '.pmd-move-handle',
            'ui-floating': true,
            stop: (e, ui) => {
                for (let i in this.curso.modulos) {
                    this.curso.modulos[i].order = Number(i) + 1;
                    FormacaoModulo.upsert(this.curso.modulos[i]);
                }
            }
        };
        this.loadData();
    }
    generateCodigo = () => {
        return "C" + ("0000000" + this.id).slice(-7);
    };
    generateCodeForModule = m => {
        return "M" + ("0000000" + m.id).slice(-7);
    };
    editModule = (module) => {
        let total = angular.copy(this.curso.duracao);
        this.curso.modulos.forEach(m => {
            if (m.id !== module.id)
                total -= m.horas;
        });
        this.UI.showDialog({
            size: 'lg',
            template: require('./module.dialog.html'),
            controller: ['$scope', $scope => {
                    $scope.horasDisponiveis = total;
                    $scope.modulo = angular.copy(module);
                    $scope.ok = () => {
                        $scope.$close($scope.modulo);
                    };
                    $scope.cancel = () => {
                        $scope.$dismiss('cancel');
                    };
                }]
        }).then(res => {
            if (res) {
                this.FormacaoModulo.upsert(res).$promise.then(() => {
                    this.loadData();
                    this.UI.addToast('Módulo editado com sucesso');
                }).catch(() => {
                    this.UI.addToast('Erro ao editar módulo');
                });
            }
        }).catch(() => {
        });
    };
    addModule = () => {
        let total = angular.copy(this.curso.duracao);
        this.curso.modulos.forEach(m => {
            total -= m.horas;
        });
        this.UI.showDialog({
            size: 'lg',
            template: require('./module.dialog.html'),
            controller: ['$scope', $scope => {
                    $scope.horasDisponiveis = total;
                    $scope.modulo = {
                        id: 0,
                        active: true,
                        cursoId: this.id
                    };
                    $scope.ok = () => {
                        $scope.$close($scope.modulo);
                    };
                    $scope.cancel = () => {
                        $scope.$dismiss('cancel');
                    };
                }]
        }).then(res => {
            if (res) {
                this.FormacaoModulo.find({
                    filter: {
                        where: {
                            cursoId: this.id,
                            active: true,
                        },
                        order: 'order DESC',
                        limit: 1
                    }
                }).$promise.then((a) => {
                    let order = 1;
                    if (a.length === 1) {
                        order = a[0].order + 1;
                    }
                    res.order = order;
                    this.FormacaoModulo.create(res).$promise.then(() => {
                        this.loadData();
                        this.UI.addToast('Módulo adicionado com sucesso');
                    }).catch(() => {
                        this.UI.addToast('Erro ao adicionar módulo');
                    });
                });
            }
        });
    };
    editDetails = () => {
        let curso = angular.copy(this.curso);
        this.UI.showDialog({
            size: 'lg',
            template: require('./course.dialog.html'),
            controller: ['$scope', 'FormacaoAreaCategoria', ($scope, FormacaoAreaCategoria) => {
                    FormacaoAreaCategoria.find({
                        filter: {
                            where: {
                                active: true
                            },
                            include: 'area'
                        }
                    }).$promise.then((areas) => {
                        $scope.areas = areas;
                    });
                    $scope.curso = {
                        id: curso.id,
                        duracao: curso.duracao,
                        designacao: curso.designacao,
                        objetivos: curso.objetivos,
                        datacriacao: curso.datacriacao,
                        publicado: (curso.publicado == 1),
                        destaque: (curso.destaque == 1),
                        active: true
                    };
                    $scope.auxArea = {
                        selected: curso.areaCategoria
                    };
                    $scope.ok = () => {
                        $scope.curso.areaCategoriaId = $scope.auxArea.selected.id;
                        $scope.$close($scope.curso);
                    };
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        }).then(res => {
            if (res) {
                this.curso.id = res.id;
                this.curso.duracao = res.duracao;
                this.curso.designacao = res.designacao;
                this.curso.objetivos = res.objetivos;
                this.curso.datacriacao = res.datacriacao;
                this.curso.areaCategoriaId = res.areaCategoriaId;
                this.curso.publicado = res.publicado;
                this.curso.destaque = res.destaque;
                if (this.curso.areaCategoria)
                    this.curso.areaCategoria.id = res.areaCategoriaId;
                this.curso.$save().then(() => {
                    this.loadData();
                    this.UI.addToast('Curso atualizado com sucesso');
                }).catch(() => {
                    this.UI.addToast('Erro ao atualizar curso');
                });
            }
        });
    };
    arquivarCurso = () => {
        let dialog = this.UI.showDialog({
            size: 'md',
            template: require('./arquivar.curso.dialog.html'),
            controller: ['$scope', ($scope) => {
                    $scope.title = "Arquivar Curso";
                    $scope.cursoDesignacao = this.curso.designacao;
                    $scope.arquivado = (this.curso.arquivado === 1);
                    $scope.ok = () => $scope.$close($scope);
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        });
        dialog.then(res => {
            if (res) {
                this.FormacaoCurso.prototype$updateAttributes({ id: this.curso.id }, { arquivado: res.arquivado, publicado: 0 }).$promise.then(() => {
                    if (res.arquivado)
                        this.UI.addToast('Curso marcado como arquivado');
                    else
                        this.UI.addToast('Curso marcado como não arquivado');
                    this.loadData();
                }).catch(() => {
                    this.UI.addToast('Erro ao arquivar curso. Verifique ligação');
                });
            }
        }).catch(() => {
        });
    };
    editObservacoes = () => {
        let wait = this.UI.showWaiting();
        this.FormacaoAreaInteresse.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((areasInteresse) => {
            this.FormacaoCurso.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { id: { neq: this.curso.id } }]
                    }
                }
            }).$promise.then((cursos) => {
                cursos.sort((a, b) => a.designacao.localeCompare(b.designacao));
                wait.close();
                let dialog = this.UI.showDialog({
                    size: 'lg',
                    template: require('./observations.dialog.html'),
                    controller: ['$scope', '$dialog', ($scope, $dialog) => {
                            $scope.observacoes = this.curso.observacoes;
                            $scope.videoUrl = this.curso.videoUrl;
                            $scope.cursos = cursos;
                            $scope.areasInteresse = areasInteresse;
                            $scope.auxCurso1Relacionado = {
                                selected: cursos.find(f => f.id === this.curso.curso1RelacionadoId),
                                infiniteScroll: { numToAdd: 20, currentItems: 20 }
                            };
                            $scope.auxCurso2Relacionado = {
                                selected: cursos.find(f => f.id === this.curso.curso2RelacionadoId),
                                infiniteScroll: { numToAdd: 20, currentItems: 20 }
                            };
                            $scope.auxCurso3Relacionado = {
                                selected: cursos.find(f => f.id === this.curso.curso3RelacionadoId),
                                infiniteScroll: { numToAdd: 20, currentItems: 20 }
                            };
                            $scope.auxAreaInteresse = {
                                selected: areasInteresse.find(f => f.id === this.curso.areaInteresseId),
                                infiniteScroll: { numToAdd: 20, currentItems: 20 }
                            };
                            // Infinite Scroll magic
                            $scope.addMoreItems = (infiniteScroll) => {
                                infiniteScroll.currentItems += infiniteScroll.numToAdd;
                            };
                            $scope.cancel = () => {
                                $dialog.dismiss('cancel');
                            };
                            $scope.isValidURL = (url) => {
                                if (url == null || url.length === 0)
                                    return true;
                                const regex = new RegExp('^(https?:\\/\\/)?' + // protocol
                                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                                    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                                    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                                    '(\\#[-a-z\\d_]*)?$', // fragment locator
                                'i');
                                return regex.test(url);
                            };
                            $scope.ok = () => {
                                if (!$scope.isValidURL($scope.videoUrl)) {
                                    this.UI.addToast("URL de Vídeo Inválido");
                                }
                                else {
                                    $dialog.close($scope);
                                }
                            };
                        }]
                });
                dialog.then((res) => {
                    if (!res.observacoes || res.observacoes.length === 0)
                        res.observacoes = null;
                    if (!res.videoUrl || res.videoUrl.length === 0)
                        res.videoUrl = null;
                    this.FormacaoCurso.prototype$updateAttributes({ id: this.curso.id }, {
                        observacoes: res.observacoes,
                        videoUrl: res.videoUrl,
                        curso1RelacionadoId: (res.auxCurso1Relacionado.selected ? res.auxCurso1Relacionado.selected.id : null),
                        curso2RelacionadoId: (res.auxCurso2Relacionado.selected ? res.auxCurso2Relacionado.selected.id : null),
                        curso3RelacionadoId: (res.auxCurso3Relacionado.selected ? res.auxCurso3Relacionado.selected.id : null),
                        areaInteresseId: (res.auxAreaInteresse.selected ? res.auxAreaInteresse.selected.id : null),
                    }).$promise.then(() => {
                        this.loadData();
                        this.UI.addToast('Curso atualizado com sucesso');
                    }).catch(() => {
                        this.UI.addToast('Ocorreu um erro ao atualizar curso');
                    });
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na obtenção de Cursos. Verifique a ligação");
                wait.close();
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na obtenção de Áreas de Interesse. Verifique a ligação");
            wait.close();
        });
    };
    editInformacaoAdicional = () => {
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./informacao.adicional.dialog.html'),
            controller: ['$scope', ($scope) => {
                    $scope.title = "Editar Informação Adicional de Curso";
                    $scope.curso = {
                        enquadramento: this.curso.enquadramento,
                        programa: this.curso.programa
                    };
                    $scope.ok = () => $scope.$close($scope.curso);
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        });
        dialog.then(res => {
            if (res) {
                this.FormacaoCurso.prototype$updateAttributes({ id: this.curso.id }, res).$promise.then(() => {
                    this.UI.addToast('Informação adicional atualizada com sucesso');
                    this.loadData();
                }).catch(() => {
                    this.UI.addToast('Erro ao atualizar informação adicional');
                });
            }
        }).catch(() => {
        });
    };
    editInformacaoComplementar = () => {
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./informacao.complementar.dialog.html'),
            controller: ['$scope', ($scope) => {
                    $scope.title = "Editar Informação Complementar de Curso";
                    $scope.curso = {
                        destinatarios: this.curso.destinatarios,
                        material: this.curso.material
                    };
                    $scope.ok = () => $scope.$close($scope.curso);
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        });
        dialog.then(res => {
            if (res) {
                this.FormacaoCurso.prototype$updateAttributes({ id: this.curso.id }, res).$promise.then(() => {
                    this.UI.addToast('Informação complementar atualizada com sucesso');
                    this.loadData();
                }).catch(() => {
                    this.UI.addToast('Erro ao atualizar informação complementar');
                });
            }
        }).catch(() => {
        });
    };
    editConteudoProgramatico = (m) => {
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./content.dialog.html'),
            controller: ['$scope', ($scope) => {
                    $scope.modulo = angular.copy(m);
                    $scope.programa = $scope.modulo.conteudo;
                    $scope.ok = () => $scope.$close($scope.programa);
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        });
        dialog.then(res => {
            if (res) {
                m.conteudo = res;
                this.FormacaoModulo.upsert(m).$promise.then(() => {
                    this.UI.addToast('Conteúdo programático atualizado com sucesso');
                }).catch(() => {
                    this.UI.addToast('Erro ao atualizar conteúdo programático');
                });
            }
        }).catch(() => {
        });
    };
    deleteModulo = (m) => {
        this.UI.showConfirm(`Deseja remover o módulo ${m.order} - ${m.designacao}?`).then(res => {
            if (res) {
                //TODO: Delete modulo
                m.active = false;
                this.FormacaoModulo.upsert(m).$promise.then(() => {
                    this.loadData();
                    this.UI.addToast('Módulo removido com sucesso');
                });
            }
        });
    };
    downloadEdicao = (e) => {
        if (e.tipoId !== 3 && (angular.isUndefined(e.morada) || angular.isUndefined(e.cp4) || angular.isUndefined(e.cp4) || angular.isUndefined(localidade))) {
            this.UI.showAlert("Não é possível exportar edição para SIGO.\nPor favor verifique se os seguintes campos estão preenchidos na empresa.\n(Morada, Código-Postal, Localidade)");
            return;
        }
        let wait = this.UI.showWaiting();
        this.FormacaoCurso.exportEdition({ id: e.id }).$promise.then(result => {
            let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + result.fileData;
            let b = document.createElement('a');
            b.href = url;
            b.download = `Acao_Formacao_A${("0000000" + e.id).slice(-7)}.xlsx`;
            b.click();
            wait.close();
        }).catch(() => {
            this.UI.addToast('Ocorreu um erro ao gerar ficheiro!');
        });
    };
    downloadModules = () => {
        let wait = this.UI.showWaiting();
        this.FormacaoCurso.exportModules({ id: this.id }).$promise.then(result => {
            let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + result.fileData;
            let b = document.createElement('a');
            b.href = url;
            b.download = `Modulos_${this.generateCodigo()}.xlsx`;
            b.click();
            wait.close();
        }).catch(() => {
            this.UI.addToast('Ocorreu um erro ao gerar ficheiro!');
        });
    };
    loadData = () => {
        this.hasLoaded = false;
        this.FormacaoCurso.findOne({
            filter: {
                where: {
                    id: this.id,
                    active: 1
                },
                include: [
                    {
                        relation: 'areaCategoria',
                        scope: {
                            include: 'area'
                        }
                    },
                    {
                        relation: 'modulos',
                        scope: {
                            where: {
                                active: true
                            }
                        }
                    },
                    {
                        relation: 'edicoes',
                        scope: {
                            where: {
                                active: true
                            },
                            include: ['tipo', 'estado', 'empresa', 'modalidade']
                        }
                    }, 'curso1Relacionado', 'curso2Relacionado', 'curso3Relacionado', 'areaInteresse'
                ]
            }
        }).$promise.then((res) => {
            if (res) {
                this.hasLoaded = true;
                this.curso = res;
            }
            else {
                this.UI.addToast('Ocorreu um erro ao carregar o curso');
                this.$state.go('app.formacao.cursos.list');
            }
        });
    };
    addEdicao = () => {
        let wait = this.UI.showWaiting();
        this.FormacaoEdicaoRegime.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((regimes) => {
            this.FormacaoEdicaoTipo.find({
                filter: {
                    where: {
                        active: 1
                    }
                }
            }).$promise.then((tipos) => {
                this.FormacaoModalidade.find({
                    filter: {
                        where: {
                            active: 1
                        }
                    }
                }).$promise.then((modalidades) => {
                    wait.close();
                    this.UI.showDialog({
                        size: 'lg',
                        template: require('./edition.dialog.html'),
                        controller: ['$scope', '$dialog', 'FormacaoEdicao', 'FormacaoEmpresa', 'FormacaoLocal', ($scope, $dialog, FormacaoEdicao, FormacaoEmpresa, FormacaoLocal) => {
                                $scope.regimes = regimes;
                                $scope.tipos = tipos;
                                $scope.modalidades = modalidades;
                                $scope.simnao = this.simnao;
                                $scope.auxTipo = {
                                    selected: undefined
                                };
                                $scope.auxEmpresa = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                $scope.auxLocal = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                $scope.auxModalidade = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                $scope.auxRegime = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                $scope.auxPublicado = {
                                    selected: undefined
                                };
                                $scope.edicao = {};
                                //Infinite Scroll Magic
                                $scope.infiniteScroll = {};
                                $scope.infiniteScroll.numToAdd = 20;
                                $scope.infiniteScroll.currentItems = 20;
                                $scope.addMoreItems = function () {
                                    $scope.infiniteScroll.currentItems += $scope.infiniteScroll.numToAdd;
                                };
                                $scope.getNoEdicao = () => {
                                    FormacaoEdicao.find({
                                        filter: {
                                            where: {
                                                active: true,
                                                ano: $scope.edicao.ano.format('YYYY'),
                                                cursoId: this.id,
                                            },
                                            limit: 1,
                                            order: 'no DESC'
                                        }
                                    }).$promise.then(r => {
                                        if (r.length > 0) {
                                            $scope.edicao.no = r[0].no + 1;
                                        }
                                        else {
                                            $scope.edicao.no = 1;
                                        }
                                    }).catch(error => {
                                        console.log(error);
                                        this.UI.addToast("Erro na consulta de Nº de Edição. Verifique a ligação");
                                    });
                                };
                                $scope.updateModal = (item) => {
                                    if (item.id === 2)
                                        FormacaoEmpresa.find({ filter: { where: { active: true } } }).$promise.then(empresas => $scope.empresas = empresas);
                                    else
                                        FormacaoLocal.find({ filter: { where: { active: true } } }).$promise.then(locais => $scope.locais = locais);
                                };
                                $scope.ok = () => {
                                    $scope.edicao.ano = moment($scope.edicao.ano).format("YYYY");
                                    $scope.edicao.id = 0;
                                    $scope.edicao.active = true;
                                    $scope.edicao.estadoId = 2; // Programada
                                    $scope.edicao.modalidadeId = $scope.auxModalidade.selected.id;
                                    $scope.edicao.tipoId = $scope.auxTipo.selected.id;
                                    $scope.edicao.regimeId = $scope.auxRegime.selected.id;
                                    $scope.edicao.publicado = $scope.auxPublicado.selected ? $scope.auxPublicado.selected.value : 0;
                                    if ($scope.edicao.tipoId === 2) {
                                        $scope.edicao.empresaId = $scope.auxEmpresa.selected.id;
                                    }
                                    else {
                                        $scope.edicao.localId = $scope.auxLocal.selected.id;
                                    }
                                    $scope.$close($scope.edicao);
                                };
                                $scope.cancel = () => {
                                    $dialog.dismiss('cancel');
                                };
                            }]
                    }).then(res => {
                        if (res) {
                            res.cursoId = this.id;
                            this.FormacaoEdicao.create(res).$promise.then(r => {
                                this.loadData();
                                this.UI.addToast("Edição adicionada com sucesso");
                            }).catch(() => {
                                this.UI.addToast("Ocorreu um erro ao adicionar edição!");
                            });
                        }
                    }).catch(() => {
                    });
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na procura de Modalidades de Formação. Verifique a ligação");
                    wait.close();
                });
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Formação. Verifique a ligação");
                wait.close();
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na procura de Regimes para Edição. Verifique a ligação");
            wait.close();
        });
    };
    getAreaFormacao = () => {
        if (this.hasLoaded) {
            if (angular.isDefined(this.curso.areaCategoria)) {
                return "<p>" + this.curso.areaCategoria.designacao + "</p><p class='hidden-sm'>(" + this.curso.areaCategoria.area.codigo + ") " + this.curso.areaCategoria.area.designacao + "</p>";
            }
            else {
                return "<p>N/D</p>";
            }
        }
        else {
            return "<p>N/D</p>";
        }
    };
    generateUUID = () => {
        let uuid = "", i, random;
        for (i = 0; i < 32; i++) {
            random = Math.random() * 16 | 0;
            if (i == 8 || i == 12 || i == 16 || i == 20) {
                uuid += "-";
            }
            uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
        }
        return uuid;
    };
    addImage = () => {
        let options = {
            size: 'lg',
            template: require('./images.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
                    $scope.images = {};
                    $scope.label = "Editar imagem do curso";
                    $scope.newFileName = '';
                    $scope.oldFileName = '';
                    $scope.uuid = this.generateUUID();
                    $scope.uploader = new this.FileUploader({
                        url: '/api/Upload/for/upload',
                        queueLimit: 1,
                        formData: [
                            {
                                key: 'value'
                            }
                        ]
                    });
                    let filter = {
                        name: 'verifyIMG',
                        fn: function (item, options) {
                            return item.type.indexOf("image/") !== -1;
                        }
                    };
                    $scope.uploader.filters.push(filter);
                    $scope.uploader.onAfterAddingFile = (item) => {
                        let partes = item.file.name.split(".");
                        $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];
                        if ($scope.uploader.queue.length > 1)
                            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
                        $scope.oldFileName = $scope.uploader.queue[0].file.name;
                    };
                    $scope.uploader.onWhenAddingFileFailed = (img) => {
                        this.UI.addToast("Por favor, carregue uma imagem");
                    };
                    $scope.uploader.onErrorItem = (response, status, headers) => {
                        this.UI.addToast("A imagem não foi carregada com sucesso");
                    };
                    $scope.uploader.onBeforeUploadItem = (item) => {
                        item.file.name = $scope.newFileName;
                    };
                    $scope.ok = () => {
                        $dialog.close($scope);
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss('cancel');
                    };
                }]
        };
        let dialogCreate = this.UI.showDialog(options);
        dialogCreate.then((ok) => {
            if (ok.newFileName) {
                let wait = this.UI.showWaiting();
                this.FormacaoCurso.prototype$updateAttributes({ id: this.id }, { imagem: ok.newFileName }).$promise.then(() => {
                    if (ok.newFileName) {
                        // File exists, upload it
                        ok.uploader.uploadAll();
                        this.loadData();
                    }
                    else {
                        // No file, just update the list
                        this.loadData();
                    }
                    wait.close();
                    this.UI.addToast("Imagem adicionada com sucesso!");
                }).catch(err => {
                    wait.close();
                    this.UI.addToast("Erro a adicionar imagem.");
                    console.log(err);
                });
            }
        }).catch((error) => {
            if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
                console.log(error);
        });
    };
}
FormacaoCursoDetailsController
    .$inject = ['$state', '$http', '$filter', 'FileUploader', 'AuthenticationService', '$sce', '$stateParams', '$timeout', 'FormacaoCurso', 'FormacaoModulo', 'UIService', 'FormacaoEdicao', 'FormacaoEdicaoTipo', 'FormacaoModalidade', 'FormacaoAreaInteresse', 'FormacaoEdicaoRegime'];
